import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Only run this code in the browser and after initial render
    if (typeof window !== 'undefined' && typeof window.fbq !== 'function') {
      // Use requestIdleCallback for non-critical operations
      const initPixel = () => {
        // Create a single script element for better performance
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.innerHTML = `
          // Initialize Meta Pixel with delayed loading
          window.fbAsyncInit = function() {
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1592415148091621', { 
              autoConfig: true, 
              debug: false 
            });
            // Delay PageView to not impact LCP
            setTimeout(function() {
              fbq('track', 'PageView');
            }, 3000);
          };
          // Load asynchronously
          setTimeout(function() {
            window.fbAsyncInit();
          }, 2000);
        `;
        // Append script to body for better performance
        document.body.appendChild(script);
      };
      // Use requestIdleCallback if available, otherwise setTimeout
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(initPixel, {
          timeout: 5000
        });
      } else {
        setTimeout(initPixel, 3000); // Delay by 3 seconds as fallback
      }
    }
  }, []);
  return null;
}
export default {
  MetaPixel
};